import React, { useState } from 'react'
import { Col, Input as Ip, Select } from 'antd'
import * as UI from 'konsys-ui'
import _ from 'lodash'
import { Query } from 'react-apollo'
import { detailMode, status, statusText } from '../constants'
import { DRIVER_LIST } from '../../../constants/graphql/query'
import { checkInt } from '../../../utils/util-services'
import { theme } from '../../../styles/_variables'

/*
date.type is type of component
0: InputWithLabel
1: input
2: Text (P)
3: Dropdown (Select)
4: Radio
5: TextArea
6: Select
7: P with Label
*/

export const colorSelector = (e) => {
  switch (e) {
    case status.AVAILABLE:
      return theme.color.success
    case status.REPAIRING:
      return theme.color.warning
    case status.IN_USE:
      return theme.color.error
    case status.OUT_OF_SERVICE:
      return theme.color.error
    default:
      return theme.color.error
  }
}

const { TextArea } = Ip

const CreateMode = ({
  data, disabled, onChangeHandler, selectedData, mutationVariables,
}) => {
  const [dropdownText, setText] = useState('เลือก')
  const [driverName, setDriverName] = useState()
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              padding: '5px',
              margin: '0 0 2px',
              onChange: e => onChangeHandler(data.id, data.valueType === 'int' ? parseInt(e.target.value, 10) : e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'truckWeight' && !checkInt(e)) {
                  e.preventDefault()
                }
              },
              type: 'text',
              step: undefined,
              min: '0',
            }}
          />
        </Col>
      )
    case 6:
      return <Col
        span={data.span}
        style={{}}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Select
            disabled={data.disabled}
            showSearch
            defaultValue={data.defaultValue}
            optionFilterProp="children"
            onChange={(e) => {
              const targetObj = _.find(selectedData[data.id], r => r.value === e)
              if (data.id === 'driverId') onChangeHandler(data.id, targetObj.value, targetObj.fleet)
              else onChangeHandler(data.id, targetObj.value)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              selectedData[data.id].map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </UI.Div>
      </Col>
    default:
      return <p>No type</p>
  }
}

const EditMode = ({
  data, disabled, onChangeHandler, initialData, selectedData, mutationVariables,
}) => {
  const [value, setValue] = useState(initialData[data.id])
  const [driverName, setDriverName] = useState()
  switch (data.type) {
    case 0:
      return (
        <Col span={data.span}>
          <UI.InputWithLabel
            {...data.props}
            width='100%'
            input={{
              padding: '5px',
              margin: '0 0 2px',
              onChange: e => onChangeHandler(data.id, data.valueType === 'int' ? parseInt(e.target.value, 10) : e.target.value),
              onKeyDown: (e) => {
                if (data.id === 'truckWeight' && !checkInt(e)) {
                  e.preventDefault()
                }
              },
              type: 'text',
              step: undefined,
              min: '0',
              disabled,
              defaultValue: initialData[data.id],
            }}
          />
        </Col>
      )
    case 2:
      return <div className='flex flex-col'>
        <UI.P {...data.props} margin='0 0 16px'>{data.label}</UI.P>
        <p className='text-lg font-semibold' style={{ color: colorSelector(initialData.status) }}>{statusText[initialData.status]}</p>
        </div>
    case 6:
      return <Col
        span={data.span}
        style={{ alignSelf: 'flex-end', margin: '0 0 16px 0' }}
      >
        <UI.Div display='flex' flexDirection='column' margin='0'>
          <UI.P margin='0 0 16px'>{data.label}</UI.P>
          <Select
            disabled={disabled || data.disabled}
            showSearch
            defaultValue={initialData[data.id]}
            optionFilterProp="children"
            onChange={(e) => {
              const targetObj = _.find(selectedData[data.id], r => r.value === e)
              onChangeHandler(data.id, targetObj.value)
            }}
            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
            }
          >
            {
              selectedData[data.id].map((v, i) => <Select.Option key={i} value={v.value}>{v.text}</Select.Option>)
            }
          </Select>
        </UI.Div>
      </Col>
    default:
      return <p>No type</p>
  }
}

export default ({
  data, mode, onChangeHandler, initialData, disabled, selectedData, mutationVariables,
}) => {
  switch (mode) {
    case detailMode.ADD:
      return (
        <CreateMode
          data={data}
          disabled={disabled}
          selectedData={selectedData}
          onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
          mutationVariables={mutationVariables}
        />
      )
    case detailMode.EDIT:
      return (
        <EditMode
          data={data}
          mode={mode}
          selectedData={selectedData}
          initialData={initialData}
          onChangeHandler={(id, value, optional) => onChangeHandler(id, value, optional)}
          mutationVariables={mutationVariables}
        />
      )
    case detailMode.VIEW:
      return (
        <EditMode
          data={data}
          mode={mode}
          disabled={true}
          initialData={initialData}
          selectedData={selectedData}
          onChangeHandler={(id, value) => onChangeHandler(id, value)}
          mutationVariables={mutationVariables}
        />
      )
    default:
      return <p>no mode</p>
  }
}
